export default {
	id: 'SIMPLE_UPGRADE_3M_53_97',
	providers: {
		stripe: '',
		braintree: '',
		paltaMap: {
			USD: 'simple_premium_3m_53_97_usd',
			EUR: 'simple_premium_3m_53_97_eur',
			GBP: 'simple_premium_3m_53_97_gbp',
			AUD: 'simple_premium_3m_79_aud',
			CAD: 'simple_premium_3m_79_cad',
			SEK: 'simple_premium_3m_629_sek',
			BRL: 'simple_premium_3m_179_brl',
			DKK: 'simple_premium_3m_389_dkk',
			NOK: 'simple_premium_3m_629_nok',
			MXN: 'simple_premium_3m_929_mxn',
			TRY: 'simple_premium_3m_1799_try',
			ARS: 'simple_premium_3m_70630_ars',
			COP: 'simple_premium_3m_214590_cop',
			CLP: 'simple_premium_3m_51430_clp',
		},
		primer: 'prd_fvpolPAKRTdN',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 3,
		intro_period_type: 'month',
		next_period_value: 3,
		next_period_type: 'month',
	},
	trial: null,
	subscription: {
		interval: 'month',
		intervalCount: 3,
		priceMap: {
			USD: 53.97,
			EUR: 53.97,
			GBP: 53.97,
			AUD: 79,
			CAD: 79,
			SEK: 629,
			BRL: 179,
			DKK: 389,
			NOK: 629,
			MXN: 929,
			TRY: 1799,
			ARS: 70630,
			COP: 214590,
			CLP: 51430,
		},
	},
	options: ($t) => ({
		barChartTooltip: $t('activity_upgrade.3mo.bar_chart_tooltip'),
		barChartLeftLabel: $t('activity_upgrade.3mo.bar_chart_left_label'),
		barChartRightLabel: $t('activity_upgrade.3mo.bar_chart_right_label'),
	}),
}
